export type SiteIdKey = 'MichaelHillAU' | 'MichaelHillNZ' | 'MichaelHillCA'

export const PRODUCT_STOCK_LOW_THRESHOLD = {
  MichaelHillAU: 3,
  MichaelHillNZ: 3,
  MichaelHillCA: 3,
}
// fallbacks if for some reason site preferences is not defined
export const STANDARD_DISPATCH_TIME = {
  MichaelHillAU: 1,
  MichaelHillNZ: 1,
  MichaelHillCA: 1,
}
// fallbacks if for some reason site preferences is not defined
export const RESIZE_DELAY = {
  MichaelHillAU: 3,
  MichaelHillNZ: 3,
  MichaelHillCA: 3,
}
// fallbacks if for some reason site preferences is not defined
export const TRANSIT_AND_STORE_PROCESSING_TIME = {
  MichaelHillAU: 2,
  MichaelHillNZ: 2,
  MichaelHillCA: 2,
}

export const AVAILABILITY_COLORS = {
  IN_STOCK: 'color:#00944A;',
  LOW_STOCK: '',
  OUT_OF_STOCK: 'color:#BB1416;',
}
